// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__z1d0W","ranges":"BmiRanges_ranges__35lti"};